










import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Framework extends Vue {
  afterMounted(app: any) {
    console.log('子应用挂载结束', app)
  }

  afterUnmounted(app: any) {
    console.log('子应用卸载结束', app)
  }

  error(err: any) {
    console.log('app报错', err)
  }
}
